const initHbsptForm = () => { 
	if (!document.querySelector('#hbspt-form')) {
		var script = document.createElement('script');
		script.src = '//js.hsforms.net/forms/v2.js';
		script.async = true;
		script.id = 'hbspt-form';
		script.onload = createHbsptForm;
		document.body.appendChild(script);
	} else {
		createHbsptForm();
	}
}


const createHbsptForm = () => { 
	const hbspt = (window as any).hbspt;
	if (!hbspt) return;
	hbspt.forms.create({
		portalId: '4039866',
		formId: '818b0cc5-c077-4526-804a-5afe4beb2b5a',
		cssClass: 'puls-hubspot-form',
		submitButtonClass: 'puls-hubspot-submit',
		target: '.hs-signup-container'
	});
}

export default initHbsptForm;